// DS: ???
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import MonetizationBlock from '../Sidebar/SidebarBlock/layouts/MonetizationBlock';
import cn from 'classnames';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { ResourceType } from '../types/resource';
import s from './SafeUrlModal.scss';
export const SafeUrlModal = ({ requestClose, href, deviation })=>{
    var _deviation_extended_relatedContent, _deviation_extended;
    const { t } = useTranslation();
    const monetizationBlock = deviation === null || deviation === void 0 ? void 0 : (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : (_deviation_extended_relatedContent = _deviation_extended.relatedContent) === null || _deviation_extended_relatedContent === void 0 ? void 0 : _deviation_extended_relatedContent.find((block)=>block.contentType.includes('monetization_') && !block.contentType.includes('dreamup'));
    let promo;
    if (monetizationBlock) {
        promo = /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
            value: {
                sectionname: monetizationBlock.contentType
            }
        }, /*#__PURE__*/ React.createElement("p", null, t('SafeUrlModal.promo.text')), /*#__PURE__*/ React.createElement(MonetizationBlock, {
            className: s['money-block'],
            block: monetizationBlock,
            deviation: deviation,
            biSectionPrefix: "link_popup_"
        }));
    } else {
        promo = /*#__PURE__*/ React.createElement("img", {
            src: "https://st.deviantart.net/eclipse/illustrations/sad_fella.png",
            alt: ""
        });
    }
    var _deviation_deviationId;
    return /*#__PURE__*/ React.createElement(Modal, {
        contentClassName: cn(s['modal-content']),
        onRequestClose: requestClose,
        heading: t('SafeUrlModal.title'),
        isOpen: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['link-info']
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("p", null, t('SafeUrlModal.link.info.start')), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement(BiLink, {
        biData: BiData({
            evid: 365,
            link_url: href,
            sectionname: BiContextProvidedValue,
            itemid: (_deviation_deviationId = deviation === null || deviation === void 0 ? void 0 : deviation.deviationId) !== null && _deviation_deviationId !== void 0 ? _deviation_deviationId : 0,
            typeid: ResourceType.DEVIATION
        }),
        href: href,
        target: "_blank",
        rel: "noreferrer ugc nofollow"
    }, href)), /*#__PURE__*/ React.createElement("p", null, t('SafeUrlModal.link.info.end'))), /*#__PURE__*/ React.createElement(GhostButton, {
        variant: "main",
        size: "large",
        biData: BiData({
            evid: 2,
            click_info: 'external_link_back'
        }),
        onClick: requestClose
    }, t('SafeUrlModal.back'))), /*#__PURE__*/ React.createElement("div", {
        className: s['divider']
    }), /*#__PURE__*/ React.createElement("div", {
        className: cn(s['promo-info'], !monetizationBlock && s['empty'])
    }, promo));
};
SafeUrlModal.displayName = 'SafeUrlModal';
export default SafeUrlModal;

//# sourceMappingURL=SafeUrlModal.js.map